<template>
  <div class="steps-container">
    <div class="steps">
      <div class="step" v-for="step in steps" v-bind:class="{ 'active': step.active == true }">
        <div class="icon"></div>
        <span v-text="step.name"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OtimizadorStep",
  props: ["steps"],
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped lang="less">
@import (reference) url('../../assets/variables.less');

.steps-container {
  --step-radius: 8px;
  --step-line: rgba(84, 99, 146, 0.42);
  --step-text: #4a5a86;
  --step-text-active: #162453;
  --step-dot-bg: #ffffff;
  --step-dot-border: rgba(84, 99, 146, 0.56);
  --step-active: #1e2c6c;

  position: relative;
  display: block;
  margin: 25px 0 25px 0;
  padding: 0;

  .steps {
    position: relative;
    display: grid;
    grid-template-columns: 33.3% 33.3% 33.3%;
    gap: 0;

    .step {
      text-align: center;
      position: relative;
      padding: 40px 8px 0;
      color: var(--step-text);
      transition: color 0.16s ease;

      span {
        display: inline-block;
        font-size: 0.76rem;
        line-height: 1.25;
        font-weight: 700;
        letter-spacing: 0.01em;
      }

      &.active {
        color: var(--step-text-active);

        &:after,
        &:before {
          background: var(--step-active);
        }

        .icon {
          background: var(--step-active);
          border-color: var(--step-active);
          box-shadow: 0 0 0 4px rgba(30, 44, 108, 0.14);
        }
      }

      .icon {
        display: block;
        background: var(--step-dot-bg);
        position: absolute;
        top: 11px;
        left: 0;
        right: 0;
        width: 16px;
        height: 16px;
        margin: auto;
        border-radius: 100%;
        border: solid 2px var(--step-dot-border);
        transition: background-color 0.16s ease, border-color 0.16s ease, box-shadow 0.16s ease;
      }

      &:after,
      &:before {
        content: "";
        position: absolute;
        width: 50%;
        height: 2px;
        display: block;
        background: var(--step-line);
        top: 21px;
        z-index: -1;
      }

      &:after {
        right: 0;
      }

      &:first-of-type {
        &:before {
          display: none;
        }
      }

      &:last-of-type {
        &:after {
          display: none;
        }
      }
    }
  }
}

@media screen and (max-width: 900px) {
  .steps-container {
    .steps {
      .step {
        padding: 38px 6px 0;

        span {
          font-size: 0.72rem;
        }
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .steps-container {
    .steps {
      .step {
        padding: 34px 4px 0;

        .icon {
          width: 16px;
          height: 16px;
          top: 10px;
        }

        &:after,
        &:before {
          top: 18px;
        }

        span {
          font-size: 0.68rem;
        }
      }
    }
  }
}
</style>
